import { ChangeDetectionStrategy, Component, Input, inject, OnInit, signal } from '@angular/core'
import { IMAGE_PATHS } from '@app/core/constants/assets.constants'
import { authEndpoints } from '@app/core/constants/valueConstants'
import { PermissionService } from '@core/services/permission-service/permission-service'
import { AuthService } from '@core/services/auth-service/auth.service'
import { UserStore } from '@core/services/user/user.store'
import { environment } from 'src/environments/environment'
import { ZardDropdownMenuComponent } from '../../../../styles/components/dropdown/dropdown.component'
import { SvgIconComponent } from '../svg-icon/svg-icon.component'
import { ZardDividerComponent } from '../../../../styles/components/divider/divider.component'
import { ZardDropdownMenuItemComponent } from '../../../../styles/components/dropdown/dropdown-item.component'
import { RouterLink } from '@angular/router'
import { PERMISSIONS } from '@app/core/constants/permissions.constants'

/** Default when parent does not pass avatarPath (e.g. school-site); header uses its own avatarPath. */
const DEFAULT_AVATAR = IMAGE_PATHS.AVATAR

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ZardDropdownMenuComponent,
        SvgIconComponent,
        ZardDividerComponent,
        ZardDropdownMenuItemComponent,
        RouterLink,
    ],
})
export class UserMenuComponent implements OnInit {
    @Input() avatarPath: string | null = null
    @Input() displayName = ''
    @Input() email = ''

    readonly defaultAvatarPath = DEFAULT_AVATAR
    readonly hasViewSettingsPermission = signal(false)

    private readonly authService = inject(AuthService)
    private readonly userStore = inject(UserStore)
    private readonly permissionService = inject(PermissionService)

    async ngOnInit(): Promise<void> {
        await this.permissionService.getPermissionsBitwise()
        const hasPermission = this.permissionService.getPermissionByName(PERMISSIONS.VIEW_SETTINGS)
        this.hasViewSettingsPermission.set(hasPermission === true)
    }

    async logout(): Promise<void> {
        await this.authService.logout()
        this.userStore.clearUserData()
        const nextUrl = window.location.origin + '/'
        window.location.href = `${environment.ssoBaseUrl}${authEndpoints.SIGNIN_PATH}?next=${encodeURIComponent(nextUrl)}`
    }
}
